export function validateIdCardNo(rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入身份证号'))
  } else if (value.length !== 18) {
    callback(new Error('请输入正确的18位身份证号'))
  } else {
    callback()
  }
}

export function validatePhone(rule, value, callback) {
  const reg = /^1[3-9]\d{9}$/
  if (value === '') {
    callback(new Error('请输入手机号'))
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的11位手机号'))
  } else {
    callback()
  }
}

export function validatePwd(rule, value, callback) {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/
  if (value === '') {
    callback(new Error('请输入密码'))
  } else if (!reg.test(value)) {
    callback(new Error('密码由6-10位数字字母组成，必须同时包含数字与字母'))
  } else {
    callback()
  }
}
